import React, { useContext, useEffect, useState } from 'react';

import styles from './index.module.less';

interface I_Props {
  item: any;
  digInfo?: any;
}

const PatientInfo = (props: I_Props) => {
  const { item, digInfo = {} } = props;

  const contentDiag = digInfo?.contentDiags?.[0];

  return (
    <div className={styles.PatientInfo_wrap}>
      <div className={styles.head}>
        <img
          className={styles.head_img}
          src="https://img12.360buyimg.com/imagetools/jfs/t1/176266/4/45229/1141/661dff8dF3562321b/fc842ac7898d0b46.png"
          alt="icon"
        />
        <div className={styles.head_title}>{item.messageContent?.cardTitle}</div>
      </div>
      <div className={styles.body}>
        <div className={styles.body_item}>
          <div className={styles.body_item__title}>患者：</div>
          <div className={styles.body_item__val}>
            {item.messageContent?.sex} {contentDiag?.patientAge}
          </div>
        </div>
        <div className={styles.body_item}>
          <div className={styles.body_item__title}>主诉：</div>
          <div className={styles.body_item__val}>{item.messageContent?.content}</div>
        </div>
      </div>
      <div className={styles.footer}>
        <div className={styles.footer_content}>
          <img
            className={styles.footer_img}
            src="https://img12.360buyimg.com/imagetools/jfs/t1/141702/15/19526/3078/5fe1b3baE169478c4/5f8fa5754f42b720.png"
            alt="icon"
          />
          <div className={styles.footer_text}>{item.messageContent?.cardHintContent}</div>
        </div>
      </div>
    </div>
  );
};

export default PatientInfo;
